import React from "react";
import Message from "../components/Message";
import { EyeIcon, EyeOffIcon, RealBoyInWindow } from "../../assets/svgIcons";
import { useOauthData } from "./oAuthData";
import "./index.scss";

const AdminAuth = () => {
  const {
    cartoonPhase,
    cartoonActivity,
    username,
    setUsername,
    password,
    setPassword,
    showPassword,
    message,
    setMessage,
    isLoading,
    showWelcome,
    passwordInputRef,
    handleUsernameFocus,
    handlePasswordFocus,
    handleBlur,
    togglePasswordVisibility,
    isButtonDisabled,
    handleSubmit,
    passwordFeedback,
  } = useOauthData();

  return (
    <div className="oauth-container">
      {/* Animated background elements */}
      <div className="background-elements">
        <div className="blob1"></div>
        <div className="blob2"></div>
        <div className="blob3"></div>
      </div>
      <div className="card-container">
        {/* Login Card */}
        <div className="login-card">
          {/* Real Boy in Window (all hand, with shoulder, half top body, full hands/face expression) */}
          <div className="realboy-center">
            <RealBoyInWindow
              phase={cartoonPhase}
              passwordState={passwordFeedback}
              cartoonActivity={cartoonActivity}
            />
          </div>

          {/* Header */}
          <div className="header">
            <h2 className="title">Welcome Back</h2>
            <p className="subtitle">Sign in to your account</p>
            {showWelcome && (
              <div className="welcome-message">
                <Message type="info" showIcon className="message-info">
                  Welcome to the Admin Dashboard! Please enter your credentials
                  to continue.
                </Message>
              </div>
            )}
            {/* If bored, display "Please do something! Make some activity." */}
            {cartoonActivity === "bore" && (
              <Message
                type="warning"
                showIcon
                bordered
                className="bore-message"
              >
                <span>
                  I'm bored... Please do something! 😑 Try entering your
                  credentials or play with the form!
                </span>
              </Message>
            )}
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="form" autoComplete="off">
            {/* Username Field */}
            <div className="field-container">
              <label htmlFor="username" className="label">
                Username
              </label>
              <div className="input-wrapper">
                <input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  onFocus={handleUsernameFocus}
                  onBlur={handleBlur}
                  required
                  className="input"
                  placeholder="Enter your username"
                  autoComplete="username"
                  spellCheck={false}
                />
              </div>
            </div>

            {/* Password Field */}
            <div className="field-container">
              <label htmlFor="password" className="label">
                Password
              </label>
              <div className="input-wrapper">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onFocus={handlePasswordFocus}
                  onBlur={handleBlur}
                  required
                  className="password-input"
                  placeholder="Enter your password"
                  ref={passwordInputRef}
                  autoComplete="current-password"
                  spellCheck={false}
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="eye-button"
                  tabIndex={0}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                </button>
              </div>
            </div>

            {/* Message Component */}
            {message.show && (
              <Message
                type={message.type}
                bordered
                showIcon
                closable
                onClose={() => setMessage({ ...message, show: false })}
                className="message-info"
              >
                {message.text}
              </Message>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isButtonDisabled}
              className="submit-button"
              tabIndex={isButtonDisabled ? -1 : 0}
              onClick={
                isButtonDisabled
                  ? (e) => {
                      e.preventDefault();
                      if (passwordInputRef.current) {
                        passwordInputRef.current.focus();
                      }
                    }
                  : undefined
              }
              onMouseDown={
                isButtonDisabled
                  ? (e) => {
                      e.preventDefault();
                      if (passwordInputRef.current) {
                        passwordInputRef.current.focus();
                      }
                    }
                  : undefined
              }
            >
              {isLoading ? (
                <div className="loading-content">
                  <div className="spinner"></div>
                  <span>Signing in...</span>
                </div>
              ) : (
                "Sign In"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminAuth;
